class GraphQlClient {
  constructor(apiUrl, apiToken) {
    this.apiUrl = apiUrl;
    this.apiToken = apiToken;
  }
  async sendRequest(query, { apiTokenOverride, signal, variables, headers } = {}) {
    const resolvedHeaders = { "Content-Type": "application/json", ...headers };
    const resolvedToken = apiTokenOverride ?? this.apiToken;
    if (resolvedToken !== void 0) {
      resolvedHeaders["Authorization"] = `Bearer ${resolvedToken}`;
    }
    console.debug(query);
    const response = await fetch(this.apiUrl, {
      method: "POST",
      headers: resolvedHeaders,
      signal,
      body: JSON.stringify({ query, variables })
    });
    if (response.ok) {
      return await response.json();
    }
    const failedRequest = {
      status: response.status,
      statusText: response.statusText,
      responseText: await response.text()
    };
    return Promise.reject(failedRequest);
  }
}
export {
  GraphQlClient
};
//# sourceMappingURL=GraphQlClient.js.map
